module.exports = __webpack_public_path__ + "static/media/cloud.e6d5afe3.png";